import {Grid, Button, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import React, {useState, useEffect, useContext} from "react";
import {Stack} from "@mui/material";
import { ApiContext } from "../../../App";
import facilityThumbnailPlaceholder from "../../../facility_thumbnail.jpeg";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BoltIcon from "@mui/icons-material/Bolt";



const FacilityThumbnailForm = ({ facility}) => {
    const { t } = useTranslation();
    
    const [currentThumbnail, setCurrentThumbnail] = useState(null);
    const [newThumbnailFile, setNewThumbnailFile] = useState(null);
    const [newThumbnailPreview, setNewThumbnailPreview] = useState(null);

    const {facilityApi} = useContext(ApiContext)

    useEffect(() => {
        facilityApi.retrieve(
            facility,
            data => {
                setCurrentThumbnail(data.thumbnail);

            },
            () => {
                alert(t("Couldn't connect to server."));
            }
        )
    },[facility])

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setNewThumbnailFile(file);
        const objectUrl = URL.createObjectURL(file);
        setNewThumbnailPreview(objectUrl);
    };

    const handleReplace = () => {

        facilityApi.updateThumbnail(
            facility,
            newThumbnailFile,
            (data)=>{
                setCurrentThumbnail(data.thumbnail);
                setNewThumbnailFile(null);
                setNewThumbnailPreview(null);
                window.alert(t("Replaced thumbnail."));

            },
            () => window.alert(t("Failed to replace thumbnail."))

        )


    };

    return (
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Stack spacing={2}>
                    <Typography variant={"subtitle2"}>
                        {t("Current thumbnail")}
                    </Typography>
                        <img
                            src={currentThumbnail ?? facilityThumbnailPlaceholder}
                            alt="Facility thumbnail"
                            style={{
                                width: "250px",
                                height: "250px",
                                objectFit: "cover",
                                objectPosition: "center"
                            }}
                        />
                    <Button variant="outlined" component="label">
                        {t("Change thumbnail")}
                        <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                    </Button>
                </Stack>

                {
                    newThumbnailPreview ?
                        <Stack direction="row" spacing={2} alignItems={"center"}>
                            <ArrowForwardIcon fontSize={"large"}/>
                            <Stack spacing={2}>
                                <Typography variant={"subtitle2"}>
                                    {t("New thumbnail preview")}
                                </Typography>
                                <img
                                    src={newThumbnailPreview}
                                    alt="New facility thumbnail"
                                    style={{
                                        width: "250px",
                                        height: "250px",
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    }}
                                />
                                <Button variant="contained" onClick={handleReplace}>
                                    {t("Replace")}
                                </Button>
                            </Stack>
                        </Stack>
                        : null
                }
            </Stack>
     );
}
 
export default FacilityThumbnailForm;